import docs from './docs';
import terms from './terms';
import email from './email';
import phone from './phone';
import address from './address';
import kyc from './kyc';
import gps from './gps';
import password from './password';
import userLimits from './user-limits';
import bankAccount from './bank-account';
import contact from './contact';

export const defaultValidators: Record<Containment.Validation['name'], any> = {
  docs,
  terms,
  email,
  phone,
  address,
  kyc,
  gps,
  password,
  user_limits: userLimits,
  bank_account: bankAccount,
  contact,
};
